"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetOpStatuses = exports.datasetOpTypes = exports.datapointStatuses = void 0;
exports.datapointStatuses = ['ACTIVE', 'MANUALLY_EXPIRED'];
exports.datasetOpTypes = ['IMPORT', 'EXPORT', 'SUBSCRIBE'];
exports.datasetOpStatuses = [
    'CREATED',
    'RUNNING',
    'INITIATED',
    'AWAITING_UPLOAD',
    'PROCESSING',
    'COMPLETED',
    'FAILED',
];
//# sourceMappingURL=Datasets.js.map